import React from "react";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";


const PendingOrders = () => {
  const columns = [
    {
      header: "Date & Time",
      accessor: "date",
      width: 12,
    },
    {
      header: "Order ID",
      accessor: "order_id",
      width: 12,
      cell: (row) => <span className="error-text">{row.order_id}</span>,
    },
    {
      header: "PO Number",
      accessor: "po_number",
      width: 12,
      cell: (row) => <span className="error-text">{row.po_number}</span>,
    },
    {
      header: "Quantity",
      accessor: "quantity",
      width: 8,
    },
    {
      header: "20 Foot",
      accessor: "20_foot",
      width: 6,
    },
    {
      header: "40 foot",
      accessor: "40_foot",
      width: 6,
    },
    {
      header: "Delivery Address",
      accessor: "delivery_address",
      width: 20,
    },
    {
      header: "PI Status",
      accessor: "pi_status",
      width: 12,
      cell: (row) => <span className="text-btn">{row.pi_status}</span>,
      className: "pi_status",
    },
    {
      header: "Order Status",
      accessor: "order_status",
      width: 12,
      cell: (row) => <span className="success-text">{row.order_status}</span>,
    },
  ];
     const data = []; //this data is static as of now
  // const data = [
  //   {
  //     date: "20-10-2021",
  //     order_id: "O1020334",
  //     po_number: "O1020334",
  //     quantity: "20",
  //     "20_foot": "5",
  //     "40_foot": "15",
  //     delivery_address: "3750 S. Watson Rd., Suite 100, Arlingto",
  //     pi_status: "Pending",
  //     order_status: "Confirmed",
  //   },
  //   {
  //     date: "20-10-2021",
  //     order_id: "O1020334",
  //     po_number: "O1020334",
  //     quantity: "20",
  //     "20_foot": "5",
  //     "40_foot": "15",
  //     delivery_address: "3750 S. Watson Rd., Suite 100, Arlingto",
  //     pi_status: "Pending",
  //     order_status: "To be Confirmed",
  //   },
  //   {
  //     date: "20-10-2021",
  //     order_id: "O1020334",
  //     po_number: "O1020334",
  //     quantity: "20",
  //     "20_foot": "5",
  //     "40_foot": "15",
  //     delivery_address: "3750 S. Watson Rd., Suite 100, Arlingto",
  //     pi_status: "Pending",
  //     order_status: "To be Confirmed",
  //   },
  //   {
  //     date: "20-10-2021",
  //     order_id: "O1020334",
  //     po_number: "O1020334",
  //     quantity: "20",
  //     "20_foot": "5",
  //     "40_foot": "15",
  //     delivery_address: "3750 S. Watson Rd., Suite 100, Arlingto",
  //     pi_status: "Pending",
  //     order_status: "Confirmed",
  //   },
  //   {
  //     date: "20-10-2021",
  //     order_id: "O1020334",
  //     po_number: "O1020334",
  //     quantity: "20",
  //     "20_foot": "5",
  //     "40_foot": "15",
  //     delivery_address: "3750 S. Watson Rd., Suite 100, Arlingto",
  //     pi_status: "Pending",
  //     order_status: "Cancelled",
  //   },
  // ];

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={"Pending Actions"}
          showGrid={false}
          searchPlaceholder={"Search by order id..."}
        >
          <Table columns={columns} data={data} action={false} actionWidth={8} />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default PendingOrders;
